import type { GetUserThreads200ItemCurrentUserStatusStatus } from './getUserThreads200ItemCurrentUserStatusStatus';

export type GetUserThreads200ItemCurrentUserStatus = {
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  invitedBy?: string | null;
  /** @nullable */
  requestedAt?: string | null;
  status: GetUserThreads200ItemCurrentUserStatusStatus;
};
